import React from "react";
import ReactGA from "react-ga4";

const useAnalyticsEventTracker = (category="Konnect Portal") => {
  const gaEventTracker = (action : string, label = '') => {
    ReactGA.event({category, action, label});
  }
  return gaEventTracker;
}
export default useAnalyticsEventTracker;